import React, { useContext } from 'react'
import { Typography, List, ListItem, ListItemIcon } from '@mui/material'
import { LocationOnOutlined, KeyboardArrowRight } from '@mui/icons-material'
import { PATHS } from '../../constants'
import { EmploymentsContext } from '../../contexts/EmploymentsContext'
import { changeSelectedStore } from '../../Utilities/authenticationService'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'

const CreateShiftStores = ({ history }) => {
    const { userEmployments: employments } = useContext(EmploymentsContext)

    return (
        <PageWithTitleLayout title="シフト表を作成する">
            <div className="shrinkable">
                <Typography variant="subtitle2" margin="1rem" marginTop=".5rem" marginBottom=".5rem">
                    希望シフトを提出する店舗を選択してください。
                </Typography>
                <List sx={{ mx: '1rem' }}>
                    {employments.map(e =>
                        e.is_manager ? (
                            <ListItem
                                key={e.id}
                                onClick={() => {
                                    changeSelectedStore(e.id)
                                    history.push(PATHS.managerStores + e.id)
                                }}
                            >
                                <ListItemIcon>
                                    <LocationOnOutlined />
                                </ListItemIcon>
                                {e.store.name}
                                <KeyboardArrowRight sx={{ ml: 'auto' }} />
                            </ListItem>
                        ) : null
                    )}
                </List>
            </div>
        </PageWithTitleLayout>
    )
}

export default CreateShiftStores
